<div id="logoContainer">
    <div #logoRef></div>
</div>

<section
    id="first"
    class="bg-black w-full h-[100svh] realtive"
    data-speed="0.5"
>
    <h1 class="sr-only">Hof Zehentmoar</h1>
    <video
        autoplay
        [muted]="'muted'"
        muted
        playsinline
        preload="auto"
        loop
        id="hof-video"
        class="w-full h-full object-cover"
        poster="images/video-poster.webp"
    >
        <source
            src="videos/website_header_mobile_compressed.webm"
            type="video/webm"
            media="(max-width: 768px)"
        />
        <source
            src="videos/website_header_mobile_compressed.mp4"
            type="video/mp4"
            media="(max-width: 768px)"
        />
        <source src="videos/website_header_compressed.webm" type="video/webm" />
        <source src="videos/website_header_compressed.mp4" type="video/mp4" />
    </video>
    <a
        [routerLink]="['/', languageService.getLanguageCode, 'hof', 'shop']"
        class="right-1/2 fixed !translate-x-1/2 ~bottom-16/20"
        (click)="umami.track('header-shop-button-click')"
    >
        <button
            class="bg-white hover:bg-gray-200 shadow-[0_0_50px_30px_rgba(0,0,0,.6)] py-3 rounded-full font-semibold text-primary text-base hover:scale-105 transition-[colors,transform] ~px-8/10"
        >
            {{ "footer.toShop" | translate }}
        </button>
    </a>
</section>
<section
    id="second"
    class="z-10 relative bg-white w-screen h-[calc(100vh+1px)] overflow-hidden"
>
    <div class="z-10 absolute inset-0 border-white ~border-[2rem]/[5rem]"></div>
    <app-full-image
        class="absolute w-full h-full parallax"
        [data]="data().fullImages[0]"
    ></app-full-image>

    <div
        class="z-10 absolute inset-0 flex flex-col justify-between overflow-hidden"
    >
        <p id="left-text" class="-translate-x-full ~text-6xl/8xl">
            HOF ZEHENTMOAR
        </p>
        <p id="right-text" class="lg:translate-x-[10%] ~text-6xl/8xl">
            GENUSS - ERLEBNIS - LANDWIRTSCHAFT
        </p>
    </div>
</section>
<p class="w-full leading-snug ~text-2xl/4xl ~px-8/40 ~mt-16/36" id="intro-text">
    Auf unserem historischen Hof im Herzen des Ennstals verbinden wir Tradition
    mit Innovation. Wir sind Tanja und Andi - zwei leidenschaftliche Landwirte,
    die ihre Tiere lieben und für außergewöhnliche Qualität brennen. Unsere
    Philosophie ist einfach: Weniger, aber besser - besonders wenn es um Fleisch
    geht. Wir hetzen nicht, denn wahre Qualität entwickelt sich langsam - in der
    Aufzucht, in der Reife, im Geschmack. Und diesen Unterschied
    <span [ngClass]="{ '!block': domHandler.isMobile }">
        <span class="opacity-0 font-caveat">.</span>
        <span
            class="-left-2 font-caveat font-bold text-primary"
            id="dynamic-word"
        ></span>
        man in jedem Bissen!
    </span>
</p>

<section
    id="third"
    class="relative lg:w-screen h-screen"
    [ngClass]="{
        'w-[300vw] sm:w-[250vw] md:w-[140vw]':
            data().bestsellers.products.length === 5,
        'w-[340vw] sm:w-[200vw] md:w-[150vw]':
            data().bestsellers.products.length === 6,
        'w-[440vw] sm:w-[220vw] md:w-[170vw]':
            data().bestsellers.products.length === 7,
    }"
>
    <app-bestsellers [data]="data().bestsellers"></app-bestsellers>
</section>
<section id="fourth" class="relative flex w-screen h-screen overflow-hidden">
    <app-full-image
        class="w-full h-full scale"
        [data]="data().fullImages[1]"
    ></app-full-image>
</section>
<section id="fifth" class="relative flex w-full h-[120vh] lg:h-[190vh]">
    @defer (on viewport) {
        <app-categories [categories]="data().categories"></app-categories>
    } @placeholder {
        <div class="size-full"></div>
    }
</section>
<section
    id="sixth"
    class="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 grid-rows-[repeat(6,min-content)] md:grid-rows-3 lg:grid-rows-2 bg-black w-full lg:h-screen"
>
    <div
        class="lg:col-start-1 lg:row-start-1 p-6 overflow-y-auto text-white text-3xl"
    >
        <app-grid-section
            [index]="0"
            [blockNodes]="data().textImageOnly[0].text"
        ></app-grid-section>
    </div>
    <img
        [src]="domHandler.generateSrcsetAsWebp(data().textImageOnly[0].image)"
        [srcset]="
            domHandler.generateSrcsetAsWebp(data().textImageOnly[0].image)
        "
        loading="lazy"
        alt="{{
            data().textImageOnly[0].image.alternativeText
        }} text image bild"
        class="lg:col-start-1 lg:row-start-2 max-lg:mx-auto size-full object-cover"
    />

    <div
        class="md:col-start-2 lg:col-start-2 md:row-start-2 lg:row-start-2 p-6 overflow-y-auto text-white text-3xl"
    >
        <app-grid-section
            [index]="1"
            [blockNodes]="data().textImageOnly[1].text"
        ></app-grid-section>
    </div>

    <img
        [src]="domHandler.generateSrcsetAsWebp(data().textImageOnly[1].image)"
        [srcset]="
            domHandler.generateSrcsetAsWebp(data().textImageOnly[1].image)
        "
        loading="lazy"
        alt="{{
            data().textImageOnly[1].image.alternativeText
        }} text image bild"
        class="md:col-start-1 lg:col-start-2 md:row-start-2 lg:row-start-1 max-lg:mx-auto size-full object-cover"
    />

    <div
        class="lg:col-start-3 lg:row-start-1 p-6 overflow-y-auto text-white text-3xl"
    >
        <app-grid-section
            [index]="2"
            [blockNodes]="data().textImageOnly[2].text"
        ></app-grid-section>
    </div>
    <img
        [src]="domHandler.generateSrcsetAsWebp(data().textImageOnly[2].image)"
        [srcset]="
            domHandler.generateSrcsetAsWebp(data().textImageOnly[2].image)
        "
        loading="lazy"
        alt="{{
            data().textImageOnly[2].image.alternativeText
        }} text image bild"
        class="lg:col-start-3 lg:row-start-2 max-lg:mx-auto size-full object-cover"
    />
</section>
<section
    id="eighth"
    class="relative flex flex-col justify-end items-center bg-white w-full h-fit lg:h-screen"
>
    <div class="flex mt-8 overflow-hidden ~text-[3rem]/[12rem]">
        <span class="inline-block text-nowrap ~mr-4/8 niceTo">NICE TO</span>
        <span class="inline-block text-nowrap meatYou"
            ><span class="text-primary">MEAT</span> YOU</span
        >
    </div>
    <app-contact-hof class="w-full"></app-contact-hof>
</section>
